import { forwardRef } from "react";

const INPUT_BASE =
  "w-full min-w-0 max-w-full rounded-md border border-slate-300 bg-white text-slate-900 placeholder:text-slate-400 outline-none transition-all duration-200 hover:border-slate-500 focus:border-slate-900 focus:ring-2 focus:ring-inset focus:ring-slate-900/35";

const SIZE_STYLES = {
  md: {
    input: "px-3 py-2.5 text-xs md:px-4 md:py-3 md:text-sm",
    label: "mb-2 gap-2 text-xs md:mb-3 md:gap-2.5 md:text-sm tracking-[0.12em] md:tracking-[0.15em]",
    icon: "h-7 w-7 md:h-8 md:w-8",
    iconInner: "text-sm md:text-base",
  },
  sm: {
    input: "px-2 py-1.5 text-[11px] md:px-2.5 md:py-1.5 md:text-xs",
    label: "mb-1 gap-1 text-[10px] md:text-[11px] tracking-[0.08em]",
    icon: "h-5 w-5",
    iconInner: "text-[10px] md:text-[11px]",
  },
};

const Input = forwardRef(function Input(
  {
    as = "input",
    label,
    /** Bootstrap icon class without `bi` prefix, e.g. `input-cursor-text` */
    labelIcon = null,
    size = "md",
    className = "",
    wrapperClassName = "",
    options = [],
    ...props
  },
  ref
) {
  const styles = SIZE_STYLES[size] ?? SIZE_STYLES.md;
  const classes = `${INPUT_BASE} ${styles.input} ${className}`.trim();

  return (
    <div className={wrapperClassName || "w-full"}>
      {label ? (
        <label
          className={`form-label flex items-center font-bold uppercase text-dark/90 ${styles.label}`}
        >
          {labelIcon ? (
            <span
              className={`inline-flex shrink-0 items-center justify-center rounded-md bg-neutral-100/75 text-dark/80 ${styles.icon}`}
            >
              <i className={`bi bi-${labelIcon} ${styles.iconInner}`} aria-hidden />
            </span>
          ) : null}
          {label}
        </label>
      ) : null}
      {as === "textarea" ? (
        <textarea ref={ref} className={classes} {...props} />
      ) : as === "select" ? (
        <select ref={ref} className={classes} {...props}>
          {options.map((option) => (
            <option
              key={option.value ?? option.label}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </option>
          ))}
        </select>
      ) : (
        <input ref={ref} className={classes} {...props} />
      )}
    </div>
  );
});

export default Input;
